import { isBoolean } from "lodash-es";
import React from "react";
import { matchPath, withRouter } from "react-router-dom";

import { IWithRouteMatchProps } from "./RouteContext";

export interface IWithRouteNavigatorWrapped {
  active?: boolean;
  exact?: boolean;
  href?: string;
  target?: string;
  onClick?: (event: React.MouseEvent<any>) => void;
}

export interface IWithRouteNavigator {
  path: string;
  state?: object;
}

export const withRouteNavigator = <P extends IWithRouteNavigatorWrapped>(Component: React.ComponentType<P>) => {
  type Props = P & IWithRouteMatchProps & IWithRouteNavigator;

  class WithRouteNavigator extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<any>) => {
      event.preventDefault();

      const { onClick, history, path, state, target } = this.props;

      if (target === "_blank") {
        window.open(path);
      } else {
        history.push(path, state);
      }

      if (onClick) {
        onClick(event);
      }
    };

    render() {
      const {
        active,
        exact = true,
        onClick,
        href,
        history,
        location,
        match,
        staticContext,
        path,
        ...restProps
      } = this.props as any;
      const computedActive = isBoolean(active)
        ? active
        : !!matchPath(location.pathname, { path, strict: false, exact });

      return <Component active={computedActive} href={path} onClick={this.handleClick} {...restProps} />;
    }
  }

  return withRouter(WithRouteNavigator);
};
